import styled from 'styled-components';

const StyledWrapper = styled.div``;

const StyledImage = styled.img`
  height: auto;
  width: 100%;
`;

export { StyledWrapper, StyledImage };
